import Home from './pages/homewebsite/home';

function App() {
  return <Home />;
}

export default App;
